// extracted by mini-css-extract-plugin
export default {"buttonLogout":"Logout_buttonLogout__Yu2zo","cardOption":"Logout_cardOption__jc7En","icon":"Logout_icon__Udk2j"};